import React, { useEffect, useState } from 'react';
import BackToTop from '../../../components/elements/BackToTop';
import HeaderStyleEight from '../../../components/Layout/Header/HeaderStyleEight';
import Footer from '../Footer';
import SiteBreadcrumb from '../../../components/Common/Breadcumb';
import BlogDetailsMain from './BlogDetailsMain';
import bannerbg from '../../../assets/images/rrc/event-poster.jpg';
import BrandSlider1 from '../../../components/Slider/BrandSlider1'
// Breadcrumbs Background Image

const BlogDetails = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <React.Fragment>
        <HeaderStyleEight />
        {/* SiteBreadcrumb */}
        <SiteBreadcrumb
            pageTitle="Yugto"
            pageName="Yugto"
            breadcrumbsImg={bannerbg}
        />
        {/* SiteBreadcrumb */}
        <BlogDetailsMain/>
        {/*cta-section */}
        <BrandSlider1 />
        {/*cta-section end */}
        <BackToTop scroll={isVisible} />
        <Footer />
    </React.Fragment>
    );
}

export default BlogDetails;